import { useEffect, useRef, useState } from "react";

// Common components
import Sidebar from "../components/common/Sidebar";
import Header from "../components/common/Header";
import { useNavigate } from "react-router-dom";
import { addAnUser, getUsersList } from "services/team";
import { format } from "date-fns";
import allImgPaths from "assets/images";
import CustomSelect from "components/common/CustomSelect";
import { InputTextField } from "components/InputField";
import Toast from "components/common/Toast";
import { Modal } from "components/common/modals/Modal";
import { HeaderModal } from "components/common/modals/Header";
import { Body } from "components/common/modals/Body";
import { FooterModal } from "components/common/modals/Footer";
import ExistingSettingMember from "./loaders/ExistingSettingMember";

const Users = () => {
    const navigate = useNavigate();
    const [isDataLoading, setIsDataLoading] = useState(false)
    const [data, setData] = useState<any>([])
    const [teams, setTeams] = useState<any>([])
    const [showAddUserModal, setShowAddUserModal] = useState(false)
    const initFormData: any = {
        name: '',
        email: '',
        password: '',
        isNew: false,
        teamName: '',
        teamId: ''
    }
    const [formData, setFormData] = useState<any>(initFormData)
    const [error, setError] = useState<any>({})
    const [showEyeBtn, setShowEyeButton] = useState({ password: false })
    const [isApiCalled, setIsApiCalled] = useState(false)

    useEffect(() => {
        fetchUsers()
    }, [])

    const fetchUsers = async () => {
        setIsDataLoading(true)
        try {
            const { data: usersList } = await getUsersList()

            if (usersList?.length) {
                setData(usersList)

                const allTeams = [
                    ...new Set(
                        usersList.flatMap((user: any) => user.teams).filter(Boolean)
                    )
                ];

                const uniqueTeams = Array.from(
                    new Map(allTeams.map((team: any) => [team._id, team])).values()
                );

                let teamsArray = uniqueTeams.map((team: any) => ({ label: team?.name, value: team?._id }))

                setTeams(teamsArray)
            }

            setIsDataLoading(false)
        } catch (error) {
            setIsDataLoading(false)
            console.log({ userListError: error })
        }
    }

    const handleInputChange = (name: any, value: any) => {
        setFormData({ ...formData, [name]: value })
    }

    const handlePassEyeBtn = () => {
        setShowEyeButton({ ...showEyeBtn, password: !showEyeBtn.password });
    };

    const handleAddTeam = (value: boolean) => {
        setFormData({ ...formData, isNew: value, teamId: '', teamName: '' })
    }

    const closeAddUserModal = () => {
        setShowAddUserModal(false)
        setFormData(initFormData)
    }

    const isFormValid = () => {
        const { email, password, name, teamName, teamId } = formData;

        const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        const isTeamSpecified = teamName?.trim() || teamId?.trim();

        return (
            email?.trim() &&
            isEmailValid &&
            password?.trim() &&
            name?.trim() &&
            isTeamSpecified
        );
    };

    const formIsValid = isFormValid();

    const addUser = async () => {
        console.log({ formData })
        setIsApiCalled(true)

        try {
            const response: any = await addAnUser(formData)

            if (response?.message == 'success') {
                await fetchUsers()
                Toast.success('', 'User added successfully')
            } else {
                Toast.error('', response?.toastMessage || 'Failed to add user')
            }

            setIsApiCalled(false)
            closeAddUserModal()
        } catch (error) {
            console.log({ addUserError: error })
            Toast.error('', 'Failed to add user')
            setIsApiCalled(false)
        }
    }

    // useEffect(() => {
    //     console.log({ formData })
    // }, [formData])

    return (
        <>
            {
                showAddUserModal &&
                <Modal className={"modal-wrapper max-w-[480px]"} isShow={true}>
                    <div>
                        <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-6 px-6">
                            <img className="w-12 h-12 mb-4" src={allImgPaths.leaveTeamIcon} alt="remove" />
                            <div className="flex items-center justify-between">
                                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">Add User</h2>
                                <img
                                    className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[130px]"
                                    id="modal-toggle"
                                    src={allImgPaths.closeIcon}
                                    onClick={closeAddUserModal}
                                    alt="close icon"
                                />
                            </div>
                        </HeaderModal>
                        <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
                            <div className="mb-5">
                                <InputTextField
                                    label={"Name"}
                                    style={error.name ? "border-red-500" : ""}
                                    name={"name"}
                                    placeholder={"Enter name"}
                                    onChange={(e: any) => handleInputChange('name', e.target.value)}
                                    value={formData.name}
                                    type="text"
                                    err={error.name}
                                />
                            </div>

                            <div className="mb-5">
                                <InputTextField
                                    label={"Email"}
                                    style={error.email ? "border-red-500" : ""}
                                    name={"email"}
                                    placeholder={"Enter email"}
                                    onChange={(e: any) => handleInputChange('email', e.target.value)}
                                    value={formData.email}
                                    type="text"
                                    err={error.email}
                                />
                            </div>

                            <div className="mb-5">
                                <InputTextField
                                    label={"Password"}
                                    name={"password"}
                                    style={error.password ? "border-red-500" : ""}
                                    placeholder={"Enter password"}
                                    onChange={(e: any) => handleInputChange('password', e.target.value)}
                                    value={formData.password}
                                    iButton={true}
                                    type={showEyeBtn.password ? "text" : "password"}
                                    handleShowEyeBtn={handlePassEyeBtn}
                                    showEyeBtn={showEyeBtn.password}
                                    err={error.password}
                                />
                            </div>
                            {
                                !formData?.isNew &&
                                <>
                                    <p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Select a team</p>
                                    <div className="modal-select-box fete-settings-modals">
                                        <CustomSelect
                                            options={teams}
                                            onChange={(e: any) => { handleInputChange('teamId', e.value) }}
                                            extendedOption={false}
                                        />
                                        <p
                                            className="text-sm text-blue-700 cursor-pointer"
                                            onClick={() => handleAddTeam(true)}
                                        >
                                            Create a new team
                                        </p>
                                    </div>
                                </>
                            }
                            {
                                formData?.isNew &&
                                <div className="mb-5">
                                    <InputTextField
                                        label={"Team Name"}
                                        name={"teamName"}
                                        placeholder={"Enter team name"}
                                        onChange={(e: any) => handleInputChange('teamName', e.target.value)}
                                        value={formData.teamName}
                                        type="text"
                                        err={error.teamName}
                                    />
                                    <p
                                        className="text-sm text-blue-700 cursor-pointer mt-2"
                                        onClick={() => handleAddTeam(false)}
                                    >
                                        Select from list
                                    </p>
                                </div>
                            }
                        </Body>

                        <FooterModal title="" isShowFooter={true} className="modal-footer pt-8 px-6 pb-4">
                            <div className="flex items-center gap-x-3 justify-center">
                                <button onClick={closeAddUserModal} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 hover:bg-[#f2f4f7]">Cancel</button>
                                <button
                                    className={`${(!formIsValid || isApiCalled) ? 'button-disabled' : ''} !text-base text-white submit-btn-blue hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1`}
                                    onClick={addUser}
                                >
                                    Add
                                </button>
                            </div>
                        </FooterModal>
                    </div>

                </Modal>
            }

            <div className="dashboard-wrapper flex">
                {/* <Sidebar /> */}

                {/* dashboard main */}
                <div className="w-[calc(100%_-_72px)]">
                    {/* <Header /> */}

                    <div className="pt-2 px-4 h-[calc(100vh_-_125px)] overflow-y-scroll scrollbar-adjust">

                        <div className="flex items-center justify-between mb-6">
                            <h3 className="text-lg font-interSemiBold text-[#101828] mb-2">
                                Users List ({data?.length})
                            </h3>
                            <button
                                type="button"
                                className="submit-btn-blue !px-[15px] !text-sm hover:bg-[#120693]"
                                onClick={() => { setShowAddUserModal(true) }}
                            >
                                Add User
                            </button>
                        </div>

                        {
                            (isDataLoading ? <ExistingSettingMember /> :
                                <div className="">
                                    <div className="custom-table-grid bg-[#F9FAFB] rounded-tl-lg rounded-tr-lg border-b-0 border border-[#EAECF0]">
                                        <div>
                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-6 inline-block">Name</span>
                                        </div>
                                        <div>
                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-6 inline-block">Email</span>
                                        </div>
                                        <div>
                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-6 inline-block">Teams</span>
                                        </div>
                                        <div>
                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-6 inline-block">Created On</span>
                                        </div>
                                    </div>
                                    <div className={`border border-[#EAECF0] rounded-bl-lg rounded-br-lg overflow-y-auto max-h-[584px] `}>
                                        {
                                            data?.length > 0 && data.map((user: any, index: number) =>
                                                <div className="custom-table-grid border-b border-[#EAECF0]" key={index}>

                                                    <div className="items-center gap-x-3 py-2 px-6 w-[100px]">
                                                        <div className="">
                                                            <h6 title={user?.name} className="line-clamp-2 text-[#101828] text-xs font-interMedium">{user?.name}</h6>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-center py-2 px-6">
                                                        <span className="text-xs text-[#475467]">{user?.email}</span>
                                                    </div>

                                                    <div className="flex items-center py-2 px-6">
                                                        <span className="text-sm text-[#475467]">
                                                            <span className="text-xs text-[#475467]">
                                                                {(user?.teams || []).map((t: any) => t?.name).filter(Boolean).join(', ') || '-'}
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <div className="flex items-center py-2 px-6">
                                                        <span className="text-xs text-[#475467]">
                                                            {user?.createdOn ? format(new Date(user?.createdOn), 'MMM dd, yyyy hh:mm:ss') : '-'}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Users;